export default "__VITE_ASSET__BVt5Psdh__"